import React from "react";
import Header from "parts/Header";
import Footer from "parts/Footer";
import { useCatalogPages } from "lib/useCatalogPages";

const CatalogPage = () => {
  const { pages, isLoading, error } = useCatalogPages();

  return (
    <main className="min-h-screen bg-slate-50">
      <Header />
      <div className="container mx-auto px-4 py-8">
        <div className="mb-10 text-center">
          <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-gold-700">Browse</p>
          <h1 className="font-display text-4xl text-maroon-900 sm:text-5xl">Product Catalog</h1>
          <p className="mx-auto mt-3 max-w-xl text-lg font-light text-slate-500">
            Scroll down to browse our full printed catalog.
          </p>
        </div>

        {isLoading && (
          <div className="flex h-64 items-center justify-center">
            <div className="h-12 w-12 animate-spin rounded-full border-t-2 border-b-2 border-maroon-700" />
          </div>
        )}

        {!isLoading && error && (
          <p className="text-center text-red-600">{error}</p>
        )}

        {!isLoading && !error && pages.length === 0 && (
          <p className="text-center text-slate-400">No catalog pages yet.</p>
        )}

        {!isLoading && !error && pages.length > 0 && (
          <div className="mx-auto flex max-w-2xl flex-col gap-8">
            {pages.map((page, index) => (
              <figure
                key={page.id}
                className="overflow-hidden rounded-lg bg-white shadow-lg transition-shadow duration-300 hover:shadow-xl"
              >
                <img
                  src={page.image_url}
                  alt={`Catalog page ${index + 1}`}
                  loading={index === 0 ? "eager" : "lazy"}
                  className="w-full"
                />
                <figcaption className="border-t border-slate-100 py-2 text-center text-sm text-slate-400">
                  Page {index + 1} of {pages.length}
                </figcaption>
              </figure>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </main>
  );
};

export default CatalogPage;
